// LOP Cart Drawer - Versión corregida con botones funcionando
(function() {
  'use strict';
  
  // Prevenir múltiples inicializaciones
  if (window.LOP_CART_DRAWER_INITIALIZED) {
    console.log('🚫 LOP Cart drawer ya inicializado, saltando...');
    return;
  }
  
  console.log('🚀 Iniciando LOP cart drawer - versión corregida...');
  
  // Marcar como inicializado INMEDIATAMENTE
  window.LOP_CART_DRAWER_INITIALIZED = true;
  window.DISABLE_ORIGINAL_CART_DRAWER = true;
  
  // Variables globales
  let isUpdating = false;
  let pendingUpdates = [];
  let lastUpdateTime = 0;
  const DEBOUNCE_TIME = 100; // Reducido de 300 a 100ms
  
  // EXPONER FUNCIONES GLOBALMENTE INMEDIATAMENTE
  function openCartDrawer() {
    console.log('🔄 [LOP] Abriendo cart drawer...');
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    
    const isDesktop = window.innerWidth >= 768;
    console.log(`📱 [LOP] Es desktop: ${isDesktop}`);
    
    let cartDrawer;
    if (cartDrawers.length > 1) {
      if (isDesktop) {
        cartDrawer = document.querySelector('.thb-header-horizontal-layout #Cart-Drawer') || cartDrawers[1];
      } else {
        cartDrawer = cartDrawers[0];
      }
    } else {
      cartDrawer = cartDrawers[0];
    }
    
    if (cartDrawer) {
      console.log('✅ [LOP] Cart drawer encontrado, abriendo...');
      cartDrawer.classList.add('active');
      cartDrawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      
      // FORZAR que el footer siempre esté visible - MEJORADO
      const footerContainer = cartDrawer.querySelector('.LOP-cart-drawer--footer');
      if (footerContainer) {
        footerContainer.style.display = 'block';
        footerContainer.style.visibility = 'visible';
        footerContainer.style.opacity = '1';
        footerContainer.style.height = 'auto';
        footerContainer.style.minHeight = 'auto';
        footerContainer.style.position = 'relative';
        footerContainer.style.bottom = '0';
        footerContainer.style.zIndex = '10';
      }
      
      console.log('🎉 [LOP] Cart drawer abierto exitosamente!');
    }
  }

  function closeCartDrawer() {
    console.log('🔄 [LOP] Cerrando cart drawer...');
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    
    cartDrawers.forEach((drawer, index) => {
      console.log(`[LOP] Cerrando cart drawer ${index + 1}...`);
      drawer.classList.remove('active');
      drawer.setAttribute('inert', '');
    });
    
    document.body.style.overflow = '';
    console.log('✅ [LOP] Cart drawer cerrado!');
  }

  // EXPONER INMEDIATAMENTE
  window.LOP = window.LOP || {};
  window.LOP.openCartDrawer = openCartDrawer;
  window.LOP.closeCartDrawer = closeCartDrawer;
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  
  console.log('✅ [LOP] Funciones globales expuestas inmediatamente');
  
  // Función de verificación del sistema
  function verifySystem() {
    console.log('=== LOP CART DRAWER VERIFICACIÓN ===');
    
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    console.log(`✅ [LOP] Cart drawers encontrados: ${cartDrawers.length}`);
    
    if (cartDrawers.length === 0) {
      console.error('❌ [LOP] No se encontraron cart drawers en el DOM');
      return false;
    }
    
    console.log('=== LOP SISTEMA VERIFICADO CORRECTAMENTE ===');
    return true;
  }

  // Función MEJORADA: regenerar cart drawer manteniendo elementos originales
  function rebuildCartDrawerFromAPI() {
    console.log('🔄 [LOP] Regenerando cart drawer desde cart.js API...');
    
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('📦 [LOP] Cart data recibida:', cart);
        console.log(`📦 [DEBUG] Items en carrito: ${cart.items.length}`);
        console.log(`📦 [DEBUG] Total: ${cart.total_price}`);
        
        // Actualizar todos los cart drawers
        const cartDrawers = document.querySelectorAll('#Cart-Drawer');
        
        cartDrawers.forEach((drawer, index) => {
          console.log(`[LOP] Regenerando drawer ${index + 1}...`);
          
          // Mantener estado de apertura
          const wasActive = drawer.classList.contains('active');
          
          // GUARDAR elementos originales para mantener estilos
          const originalItems = Array.from(drawer.querySelectorAll('.LOP-cart-item'));
          const originalRemoveButtons = originalItems.map(item => {
            const removeBtn = item.querySelector('.LOP-cart-item--remove');
            return removeBtn ? removeBtn.cloneNode(true) : null;
          });
          
          // Regenerar contenido del cart drawer
          const newContent = generateCartDrawerContent(cart, originalRemoveButtons);
          const contentContainer = drawer.querySelector('.LOP-cart-drawer--content');
          const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
          
          if (contentContainer) {
            contentContainer.innerHTML = newContent.content;
            console.log(`✅ [LOP] Contenido regenerado para drawer ${index + 1}`);
          }
          
          if (footerContainer) {
            footerContainer.innerHTML = newContent.footer;
            console.log(`✅ [LOP] Footer regenerado para drawer ${index + 1}`);
            
            // FORZAR que el footer siempre esté visible - MEJORADO
            footerContainer.style.display = 'block';
            footerContainer.style.visibility = 'visible';
            footerContainer.style.opacity = '1';
            footerContainer.style.height = 'auto';
            footerContainer.style.minHeight = 'auto';
            footerContainer.style.position = 'relative';
            footerContainer.style.bottom = '0';
            footerContainer.style.zIndex = '10';
          }
          
          // Actualizar clases del drawer
          if (cart.items.length === 0) {
            drawer.classList.add('LOP-cart-drawer--empty');
            // Asegurar que el footer esté visible incluso cuando está vacío
            if (footerContainer) {
              footerContainer.style.display = 'block';
              footerContainer.style.visibility = 'visible';
              footerContainer.style.opacity = '1';
            }
          } else {
            drawer.classList.remove('LOP-cart-drawer--empty');
          }
          
          // Restaurar estado de apertura si ya estaba abierto
          if (wasActive) {
            drawer.classList.add('active');
            drawer.removeAttribute('inert');
            document.body.style.overflow = 'hidden';
            console.log(`✅ [LOP] Estado activo restaurado para drawer ${index + 1}`);
          }
        });

        // Actualizar contador del carrito
        updateCartCounter(cart.item_count);
        
        // Reinicializar event listeners con delay para asegurar que el contenido se renderice
        setTimeout(() => {
          console.log('🔄 [LOP] Reinicializando event listeners...');
          initQuantityButtons();
          initRemoveButtons();
          initCartDrawer();
          
          // FORZAR nuevamente la visibilidad del footer después del delay - MEJORADO
          cartDrawers.forEach(drawer => {
            const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
            if (footerContainer) {
              footerContainer.style.display = 'block';
              footerContainer.style.visibility = 'visible';
              footerContainer.style.opacity = '1';
              footerContainer.style.height = 'auto';
              footerContainer.style.minHeight = 'auto';
              footerContainer.style.position = 'relative';
              footerContainer.style.bottom = '0';
              footerContainer.style.zIndex = '10';
            }
          });
        }, 150); // Aumentado de 100 a 150ms
        
        console.log('✅ [LOP] Cart drawer regenerado completamente');
        return cart;
      })
      .catch(error => {
        console.error('❌ [LOP] Error al regenerar cart drawer:', error);
        throw error;
      });
  }

  // Función para generar contenido del cart drawer MEJORADA
  function generateCartDrawerContent(cart, originalRemoveButtons = []) {
    let contentHTML = '';
    let footerHTML = '';
    
    if (cart.items.length === 0) {
      contentHTML = `
        <div class="cart-empty">
          <h3>Tu carrito está vacío</h3>
          <p>Agrega algunos productos para empezar a comprar.</p>
        </div>
      `;
    } else {
      // Generar items del carrito
      cart.items.forEach((item, index) => {
        const lineNumber = index + 1;
        const itemPrice = item.final_line_price || item.line_price;
        const originalPrice = item.original_line_price || item.line_price;
        const hasDiscount = originalPrice !== itemPrice;
        
        // Usar botón original si existe, sino usar genérico
        let removeButtonHTML = '';
        if (originalRemoveButtons[index]) {
          // Actualizar data-index del botón original
          const originalBtn = originalRemoveButtons[index];
          originalBtn.setAttribute('data-index', lineNumber);
          removeButtonHTML = originalBtn.outerHTML;
        } else {
          // Usar botón genérico como fallback
          removeButtonHTML = `
            <button type="button" class="LOP-cart-item--remove" data-index="${lineNumber}" aria-label="Eliminar ${item.product_title}">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          `;
        }
        
        contentHTML += `
          <div class="LOP-cart-item" id="CartDrawerItem-${lineNumber}">
            <div class="LOP-cart-item--image">
              <a href="${item.url || '#'}" title="${item.product_title}">
                ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
              </a>
            </div>
            
            <div class="LOP-cart-item--info">
              <div class="LOP-cart-item--details">
                <a href="${item.url || '#'}" title="${item.product_title}" class="LOP-cart-item--title">${item.product_title}</a>
                
                ${item.variant_title && item.variant_title !== 'Default Title' ? `
                  <div class="LOP-cart-item--options">${item.variant_title}</div>
                ` : ''}
                
                <div class="LOP-cart-item--price">
                  ${hasDiscount ? `<del class="LOP-cart-item--price-original">${formatMoney(originalPrice)}</del>` : ''}
                  <ins class="LOP-cart-item--price-final">${formatMoney(itemPrice)}</ins>
                </div>
              </div>
              
              <div class="LOP-cart-item--actions">
                <quantity-selector class="quantity cart-update small-qty" data-id="${item.key}">
                  <button class="minus ${item.quantity <= 1 ? 'disabled' : ''}" type="button" aria-label="Disminuir cantidad de ${item.product_title}">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M2 6H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                  <input
                    type="number"
                    name="updates[${item.id}]"
                    id="updates_${item.id}"
                    value="${item.quantity}"
                    min="1"
                    class="qty"
                    data-index="${lineNumber}"
                    data-id="${item.key}"
                    aria-label="Cantidad de ${item.product_title}"
                  >
                  <button class="plus" type="button" aria-label="Aumentar cantidad de ${item.product_title}">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M6 2V10M2 6H10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                </quantity-selector>
                
                ${removeButtonHTML}
              </div>
            </div>
          </div>
        `;
      });
    }
    
    // SIEMPRE generar footer (tanto para carrito vacío como con items)
    footerHTML = `
      <div class="LOP-cart-drawer--free-shipping">
        ${cart.items.length === 0 ? 'Agrega productos para ver el envío' : 
          cart.total_price >= 10000 ? 'Tu envío es GRATIS' : 
          `Gasta ${formatMoney(10000 - cart.total_price)} más para envío GRATIS.`}
      </div>
      
      <div class="LOP-cart-drawer--summary">
        <div class="LOP-cart-drawer--subtotal">
          <span class="LOP-cart-drawer--subtotal-label">Subtotal</span>
          <span class="LOP-cart-drawer--subtotal-amount">${formatMoney(cart.total_price)}</span>
        </div>
      </div>

      <div class="LOP-cart-drawer--buttons">
        <div class="LOP-cart-drawer--buttons-container">
          ${cart.items.length === 0 ? `
            <button type="button" class="LOP-cart-drawer--button LOP-cart-drawer--button-primary" onclick="closeCartDrawer()" title="Seguir comprando">Seguir comprando</button>
          ` : `
            <a href="/cart" class="LOP-cart-drawer--button LOP-cart-drawer--button-secondary" title="Ver carrito">Ver carrito</a>
            <form action="/cart" method="post" novalidate>
              <button type="submit" class="LOP-cart-drawer--button LOP-cart-drawer--button-primary" name="checkout" title="Finalizar compra">Finalizar compra</button>
            </form>
          `}
        </div>
      </div>
    `;
    
    return { content: contentHTML, footer: footerHTML };
  }

  // Función helper para formatear dinero
  function formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount);
  }

  // Función para actualizar contador del carrito
  function updateCartCounter(itemCount) {
    const cartCounts = document.querySelectorAll('.thb-secondary-area--item-count, [data-cart-count]');
    cartCounts.forEach(count => {
      count.textContent = itemCount;
    });
    console.log(`✅ [LOP] Contador actualizado: ${itemCount} items`);
  }

  // ================================
  // NUEVAS FUNCIONES CORREGIDAS
  // ================================

  // Event handler MEJORADO para quantity buttons
  function handleQuantityClick(e) {
    // Solo procesar clicks en botones de cantidad del cart drawer
    const button = e.target.closest('.quantity .plus, .quantity .minus, quantity-selector .plus, quantity-selector .minus');
    if (!button) return;
    
    // Verificar que el botón esté dentro de un cart drawer activo
    const cartDrawer = button.closest('#Cart-Drawer');
    if (!cartDrawer) {
      console.log('⚠️ [LOP] Botón no está en cart drawer, ignorando');
      return;
    }
    
    // PREVENIR EVENTOS DUPLICADOS
    if (e.defaultPrevented) {
      console.log('⚠️ [LOP] Evento ya procesado, ignorando');
      return;
    }
    
    e.preventDefault();
    e.stopPropagation();
    
    if (button.disabled || button.classList.contains('processing')) {
      console.log('⚠️ [LOP] Botón deshabilitado o procesando, ignorando');
      return;
    }
    
    console.log(`🖱️ [DEBUG] Botón quantity clickeado:`, button);
    
    // Marcar botón como procesando INMEDIATAMENTE
    button.disabled = true;
    button.classList.add('processing');
    
    // Encontrar el input de cantidad asociado
    const quantityContainer = button.closest('quantity-selector') || button.closest('.quantity');
    const input = quantityContainer ? quantityContainer.querySelector('.qty, input[type="number"]') : null;
    
    if (!input) {
      console.error('❌ [DEBUG] No se encontró input de cantidad');
      resetButton(button);
      return;
    }
    
    console.log(`🔍 [DEBUG] Input encontrado:`, {
      name: input.name,
      value: input.value,
      id: input.id,
      dataIndex: input.dataset.index,
      dataId: input.dataset.id
    });
    
    let currentValue = parseInt(input.value) || 1;
    let newValue = currentValue;
    
    if (button.classList.contains('minus')) {
      newValue = Math.max(0, currentValue - 1);
      console.log(`➖ [DEBUG] Minus clickeado: ${currentValue} → ${newValue}`);
    } else if (button.classList.contains('plus')) {
      newValue = currentValue + 1;
      console.log(`➕ [DEBUG] Plus clickeado: ${currentValue} → ${newValue}`);
    }
    
    // Actualizar valor inmediatamente para feedback visual
    input.value = newValue;
    
    // Determinar el identificador correcto
    const identifier = getCartItemIdentifier(input, quantityContainer);
    if (!identifier) {
      console.error('❌ [DEBUG] No se pudo determinar identificador del item');
      input.value = currentValue; // Revertir cambio
      resetButton(button);
      return;
    }
    
    console.log(`📤 [DEBUG] Actualizando item con identificador: ${identifier}, cantidad: ${newValue}`);
    
    // Llamar a la función de actualización
    updateCartItemFixed(identifier, newValue, button, input, currentValue);
  }

  // Función MEJORADA para determinar el identificador del item
  function getCartItemIdentifier(input, quantityContainer) {
    console.log('🔍 [DEBUG] Determinando identificador del item...');
    
    // 1. Intentar extraer variant ID del name del input (más confiable)
    if (input.name && input.name.includes('[') && input.name.includes(']')) {
      const match = input.name.match(/updates\[(\d+)\]/);
      if (match && match[1]) {
        console.log(`✅ [DEBUG] Variant ID encontrado en name: ${match[1]}`);
        return match[1];
      }
    }
    
    // 2. Usar data-id del container quantity-selector
    if (quantityContainer && quantityContainer.dataset.id) {
      const dataId = quantityContainer.dataset.id;
      console.log(`✅ [DEBUG] Data-ID del container: ${dataId}`);
      return dataId;
    }
    
    // 3. Usar data-id del input
    if (input.dataset.id) {
      console.log(`✅ [DEBUG] Data-ID del input: ${input.dataset.id}`);
      return input.dataset.id;
    }
    
    // 4. Fallback a data-index (line number)
    if (input.dataset.index) {
      console.log(`✅ [DEBUG] Usando line index como fallback: ${input.dataset.index}`);
      return input.dataset.index;
    }
    
    console.error('❌ [DEBUG] No se pudo determinar identificador');
    return null;
  }

  // Función MEJORADA para actualizar items del carrito
  function updateCartItemFixed(identifier, quantity, button, input, originalValue) {
    console.log(`🔄 [LOP] === INICIANDO ACTUALIZACIÓN MEJORADA ===`);
    console.log(`🔄 [LOP] ID: ${identifier}, Cantidad: ${quantity}`);
    
    const now = Date.now();
    if (now - lastUpdateTime < DEBOUNCE_TIME) {
      console.log('⏳ [LOP] Ignorando actualización debido al debounce');
      resetButton(button);
      input.value = originalValue;
      return;
    }
    lastUpdateTime = now;

    if (isUpdating) {
      console.log('⏳ [LOP] Ya hay una actualización en curso, encolando...');
      pendingUpdates = [{ identifier, quantity, button, input, originalValue }];
      resetButton(button);
      input.value = originalValue;
      return;
    }

    isUpdating = true;
    document.body.classList.add('cart-updating');
    
    // Determinar si usar variant ID o line index
    let payload;
    const idString = String(identifier);
    
    // Si el ID tiene más de 8 dígitos, probablemente es un variant ID
    if (idString.length > 8 && !idString.includes(':')) {
      payload = {
        id: idString,
        quantity: parseInt(quantity)
      };
      console.log(`📤 [DEBUG] Usando variant ID payload:`, payload);
    } else if (idString.includes(':')) {
      // Es un cart key, usar line index
      const lineIndex = input.dataset.index;
      if (!lineIndex) {
        console.error('❌ [DEBUG] Cart key detectado pero no hay line index');
        resetButton(button);
        input.value = originalValue;
        isUpdating = false;
        document.body.classList.remove('cart-updating');
        return;
      }
      payload = {
        line: parseInt(lineIndex),
        quantity: parseInt(quantity)
      };
      console.log(`📤 [DEBUG] Cart key detectado, usando line index payload:`, payload);
    } else {
      // Usar como line index
      payload = {
        line: parseInt(identifier),
        quantity: parseInt(quantity)
      };
      console.log(`📤 [DEBUG] Usando line index payload:`, payload);
    }
    
    // Realizar la actualización
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(response => {
      console.log(`📡 [DEBUG] Response status: ${response.status}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(cart => {
      console.log('✅ [LOP] Carrito actualizado exitosamente');
      console.log('📦 [DEBUG] Nuevo estado del carrito:', {
        itemCount: cart.item_count,
        totalPrice: cart.total_price,
        itemsLength: cart.items?.length
      });
      
      // Regenerar cart drawer
      return rebuildCartDrawerFromAPI();
    })
    .catch(error => {
      console.error('❌ [LOP] Error al actualizar carrito:', error);
      
      // Revertir cambio visual en caso de error
      input.value = originalValue;
      
      // Mostrar mensaje de error al usuario
      showErrorMessage('Error al actualizar el carrito. Intenta de nuevo.');
      
      // Intentar regenerar de todas formas
      rebuildCartDrawerFromAPI();
    })
    .finally(() => {
      isUpdating = false;
      document.body.classList.remove('cart-updating');
      resetButton(button);
      
      // Procesar actualizaciones pendientes
      if (pendingUpdates.length > 0) {
        const nextUpdate = pendingUpdates.shift();
        setTimeout(() => {
          updateCartItemFixed(nextUpdate.identifier, nextUpdate.quantity, nextUpdate.button, nextUpdate.input, nextUpdate.originalValue);
        }, DEBOUNCE_TIME);
      }
      
      console.log(`🔄 [LOP] === FIN DE ACTUALIZACIÓN ===`);
    });
  }

  // Función helper para resetear estado del botón
  function resetButton(button) {
    button.disabled = false;
    button.classList.remove('processing');
  }

  // Función para mostrar errores
  function showErrorMessage(message) {
    console.error('💬 [USER ERROR]:', message);
    // Aquí puedes agregar tu lógica de UI para mostrar errores
    // Por ejemplo: toast, modal, etc.
  }

  // Función MEJORADA para inicializar botones de cantidad
  function initQuantityButtons() {
    console.log('🔧 [LOP] Inicializando botones de cantidad...');
    
    // IMPORTANTE: Remover TODOS los event listeners existentes
    document.removeEventListener('click', handleQuantityClick);
    
    // También remover cualquier listener directo que pueda existir
    const existingButtons = document.querySelectorAll('.quantity .plus, .quantity .minus, quantity-selector .plus, quantity-selector .minus');
    existingButtons.forEach(button => {
      button.replaceWith(button.cloneNode(true));
    });
    
    // Usar SOLO event delegation
    document.addEventListener('click', handleQuantityClick);
    
    console.log('✅ [LOP] Event delegation configurado para quantity buttons (sin duplicados)');
  }

  // Función MEJORADA para inicializar botones de eliminar
  function initRemoveButtons() {
    console.log('🔧 [LOP] Inicializando botones de eliminar...');
    
    // Remover listener existente si existe
    document.removeEventListener('click', handleRemoveClick);
    
    // Usar event delegation
    document.addEventListener('click', handleRemoveClick);
    
    console.log('✅ [LOP] Event delegation configurado para remove buttons');
  }

  // Event handler para botones de eliminar
  function handleRemoveClick(e) {
    const button = e.target.closest('.LOP-cart-item--remove');
    if (!button) return;
    
    // Verificar que esté en un cart drawer
    const cartDrawer = button.closest('#Cart-Drawer');
    if (!cartDrawer) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    if (button.disabled) return;
    
    console.log(`🗑️ [DEBUG] Botón eliminar clickeado:`, button);
    
    button.disabled = true;
    
    // Encontrar el item del carrito
    const cartItem = button.closest('.LOP-cart-item');
    if (!cartItem) {
      console.error('❌ [DEBUG] No se encontró cart item');
      button.disabled = false;
      return;
    }
    
    // Encontrar el input de cantidad
    const input = cartItem.querySelector('.qty, input[type="number"]');
    if (!input) {
      console.error('❌ [DEBUG] No se encontró input en item a eliminar');
      button.disabled = false;
      return;
    }
    
    cartItem.style.opacity = "0.5";
    
    // Usar data-index del botón o del input
    let identifier = button.dataset.index || input.dataset.index;
    
    // Si no hay data-index, intentar extraer del name
    if (!identifier && input.name) {
      const match = input.name.match(/updates\[(\d+)\]/);
      if (match && match[1]) {
        identifier = match[1];
      }
    }
    
    if (!identifier) {
      console.error('❌ [DEBUG] No se pudo determinar identificador para eliminar');
      button.disabled = false;
      cartItem.style.opacity = "";
      return;
    }
    
    console.log(`📤 [DEBUG] Eliminando item con identificador: ${identifier}`);
    updateCartItemFixed(identifier, 0, button, input, parseInt(input.value) || 1);
  }

  // Función para debuggear el sistema de cantidades
  function debugQuantitySystem() {
    console.log('=== DEBUG QUANTITY SYSTEM ===');
    
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    console.log(`📊 Cart drawers encontrados: ${cartDrawers.length}`);
    
    cartDrawers.forEach((drawer, drawerIndex) => {
      const isActive = drawer.classList.contains('active');
      console.log(`📦 Drawer ${drawerIndex + 1} (active: ${isActive}):`);
      
      const quantityContainers = drawer.querySelectorAll('quantity-selector, .quantity');
      console.log(`  📊 Quantity containers: ${quantityContainers.length}`);
      
      quantityContainers.forEach((container, index) => {
        const input = container.querySelector('.qty, input[type="number"]');
        const plusBtn = container.querySelector('.plus');
        const minusBtn = container.querySelector('.minus');
        
        console.log(`  📦 Container ${index + 1}:`, {
          containerDataId: container.dataset.id,
          inputName: input?.name,
          inputValue: input?.value,
          inputDataIndex: input?.dataset.index,
          inputDataId: input?.dataset.id,
          hasPlusBtn: !!plusBtn,
          hasMinusBtn: !!minusBtn,
          plusDisabled: plusBtn?.disabled,
          minusDisabled: minusBtn?.disabled
        });
      });
    });
  }

  // Función para debuggear event listeners
  function debugEventListeners() {
    console.log('=== DEBUG EVENT LISTENERS ===');
    
    const buttons = document.querySelectorAll('.quantity .plus, .quantity .minus');
    buttons.forEach((button, index) => {
      console.log(`Botón ${index + 1}:`, {
        element: button,
        disabled: button.disabled,
        processing: button.classList.contains('processing'),
        parentContainer: button.closest('quantity-selector')?.dataset.id || 'N/A'
      });
    });
  }

  // Resto de funciones sin cambios...
  function initCartDrawer() {
    console.log('🔧 [LOP] Inicializando cart drawer...');
    
    const cartToggle = document.querySelectorAll('#cart-drawer-toggle, [data-cart-drawer-toggle]');
    const cartDrawers = document.querySelectorAll('#Cart-Drawer');
    
    cartToggle.forEach(toggle => {
      if (toggle) {
        const newToggle = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(newToggle, toggle);
        
        newToggle.addEventListener('click', function(e) {
          e.preventDefault();
          openCartDrawer();
        });
      }
    });

    cartDrawers.forEach(cartDrawer => {
      const closeButton = cartDrawer.querySelector('.LOP-cart-drawer--close');
      const overlay = cartDrawer.querySelector('.LOP-cart-drawer--overlay');
      
      if (closeButton) {
        const newCloseButton = closeButton.cloneNode(true);
        closeButton.parentNode.replaceChild(newCloseButton, closeButton);
        newCloseButton.addEventListener('click', closeCartDrawer);
      }
      
      if (overlay) {
        const newOverlay = overlay.cloneNode(true);
        overlay.parentNode.replaceChild(newOverlay, overlay);
        newOverlay.addEventListener('click', closeCartDrawer);
      }
    });
  }

  function listenForAddToCartDelegated() {
    console.log('🔧 [LOP] Configurando listener para formularios de add to cart...');
    
    document.body.addEventListener('submit', function (e) {
      if (e.target.matches('form[action^="/cart/add"]')) {
        e.preventDefault();
        const form = e.target;
        const formData = new FormData(form);

        console.log('📝 [LOP] Formulario de producto interceptado');

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          console.log(`📡 [DEBUG] Add to cart response status: ${response.status}`);
          return response.json();
        })
        .then(data => {
          console.log('✅ [LOP] Producto agregado (form):', data);
          return rebuildCartDrawerFromAPI();
        })
        .then(() => {
          // SIEMPRE abrir el cart drawer después de agregar producto
          setTimeout(() => {
            openCartDrawer();
            
            // FORZAR nuevamente la visibilidad del footer después de abrir - MEJORADO
            setTimeout(() => {
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                if (footerContainer) {
                  footerContainer.style.display = 'block';
                  footerContainer.style.visibility = 'visible';
                  footerContainer.style.opacity = '1';
                  footerContainer.style.height = 'auto';
                  footerContainer.style.minHeight = 'auto';
                  footerContainer.style.position = 'relative';
                  footerContainer.style.bottom = '0';
                  footerContainer.style.zIndex = '10';
                }
              });
            }, 100);
            
            // VERIFICACIÓN ADICIONAL ESPECÍFICA PARA PRIMER ITEM
            setTimeout(() => {
              console.log('🔄 [LOP] Verificación adicional para primer item...');
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                const contentContainer = drawer.querySelector('.LOP-cart-drawer--content');
                
                if (footerContainer && contentContainer) {
                  // Verificar si hay items en el contenido
                  const hasItems = contentContainer.querySelector('.LOP-cart-item');
                  
                  if (hasItems) {
                    console.log('✅ [LOP] Items detectados, asegurando footer visible...');
                    // Forzar visibilidad del footer cuando hay items
                    footerContainer.style.display = 'block';
                    footerContainer.style.visibility = 'visible';
                    footerContainer.style.opacity = '1';
                    footerContainer.style.height = 'auto';
                    footerContainer.style.minHeight = 'auto';
                    footerContainer.style.position = 'relative';
                    footerContainer.style.bottom = '0';
                    footerContainer.style.zIndex = '10';
                    
                    // También asegurar que el drawer no tenga la clase empty
                    drawer.classList.remove('LOP-cart-drawer--empty');
                  }
                }
              });
            }, 300); // Delay adicional para asegurar que el contenido se haya renderizado
          }, 200);
        })
        .catch(error => {
          console.error('❌ [LOP] Error al agregar producto:', error);
        });
      }
    });
  }

  function listenForAddToCartButtons() {
    console.log('🔧 [LOP] Configurando listener para botones de add to cart...');
    
    let isAddingToCart = false;
    
    document.body.addEventListener('click', function (e) {
      const button = e.target.closest('[data-product-id]');
      if (button && button.matches('.product-card--add-to-cart-button') && !isAddingToCart) {
        e.preventDefault();
        const variantId = button.getAttribute('data-product-id');
        if (!variantId) return;

        isAddingToCart = true;
        button.disabled = true;

        console.log('📝 [LOP] Botón add to cart clickeado');

        const payload = { id: variantId, quantity: 1 };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
        .then(res => {
          console.log(`📡 [DEBUG] Add to cart button response status: ${res.status}`);
          return res.json();
        })
        .then(data => {
          console.log('✅ [LOP] Producto agregado (botón suelto):', data);
          return rebuildCartDrawerFromAPI();
        })
        .then(() => {
          // SIEMPRE abrir el cart drawer después de agregar producto
          setTimeout(() => {
            openCartDrawer();
            
            // FORZAR nuevamente la visibilidad del footer después de abrir - MEJORADO
            setTimeout(() => {
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                if (footerContainer) {
                  footerContainer.style.display = 'block';
                  footerContainer.style.visibility = 'visible';
                  footerContainer.style.opacity = '1';
                  footerContainer.style.height = 'auto';
                  footerContainer.style.minHeight = 'auto';
                  footerContainer.style.position = 'relative';
                  footerContainer.style.bottom = '0';
                  footerContainer.style.zIndex = '10';
                }
              });
            }, 100);
            
            // VERIFICACIÓN ADICIONAL ESPECÍFICA PARA PRIMER ITEM
            setTimeout(() => {
              console.log('🔄 [LOP] Verificación adicional para primer item...');
              const cartDrawers = document.querySelectorAll('#Cart-Drawer');
              cartDrawers.forEach(drawer => {
                const footerContainer = drawer.querySelector('.LOP-cart-drawer--footer');
                const contentContainer = drawer.querySelector('.LOP-cart-drawer--content');
                
                if (footerContainer && contentContainer) {
                  // Verificar si hay items en el contenido
                  const hasItems = contentContainer.querySelector('.LOP-cart-item');
                  
                  if (hasItems) {
                    console.log('✅ [LOP] Items detectados, asegurando footer visible...');
                    // Forzar visibilidad del footer cuando hay items
                    footerContainer.style.display = 'block';
                    footerContainer.style.visibility = 'visible';
                    footerContainer.style.opacity = '1';
                    footerContainer.style.height = 'auto';
                    footerContainer.style.minHeight = 'auto';
                    footerContainer.style.position = 'relative';
                    footerContainer.style.bottom = '0';
                    footerContainer.style.zIndex = '10';
                    
                    // También asegurar que el drawer no tenga la clase empty
                    drawer.classList.remove('LOP-cart-drawer--empty');
                  }
                }
              });
            }, 300); // Delay adicional para asegurar que el contenido se haya renderizado
          }, 200);
        })
        .catch(err => {
          console.error('❌ [LOP] Error al agregar:', err);
        })
        .finally(() => {
          isAddingToCart = false;
          button.disabled = false;
        });
      }
    });
  }

  // Función de inicialización principal
  function initialize() {
    console.log('🚀 [LOP] Inicializando cart drawer...');
    
    if (!verifySystem()) {
      console.error('❌ [LOP] Sistema no válido, abortando inicialización');
      return;
    }
    
    initCartDrawer();
    initQuantityButtons();
    initRemoveButtons();
    listenForAddToCartDelegated();
    listenForAddToCartButtons();
    
    // Agregar funciones adicionales a window.LOP
    window.LOP.rebuildCartDrawerFromAPI = rebuildCartDrawerFromAPI;
    window.LOP.debugQuantitySystem = debugQuantitySystem;
    window.LOP.showErrorMessage = showErrorMessage;
    window.updateCartDrawer = rebuildCartDrawerFromAPI;
    window.LOP.debugEventListeners = debugEventListeners;
    
    console.log('🎉 [LOP] Cart drawer inicializado correctamente');
    console.log('✅ [LOP] Funciones disponibles globalmente:', Object.keys(window.LOP));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();